import { KeyValueI } from '../common';

export interface OrderListMapperI {
  select?: boolean;
  favorite?: boolean;
  img?: boolean;
  orderNumber: string;
  identity: string;
  contact: string;
  salesRep: string;
  account: string;
  type: string;
  date: string;
  bookedDate: string;
  status: string;
  payment: string;
  total: string;
  corporateIdentity: string;
  projectName: string;
  orderDate: string;
  customerPo: string;
  csrName: string;
  creditTerms: string;
  productionManager: string;
  shipVia: string;
  inRushOrder: string;
  customerShipDate: string;
  billComplete: string;
  customerInHandsDate: string;
  tasksTotal: number;
  tasksDone: number;
  comments: number;
  id: string;
  orderNoWithPrefix: string;
  altNumber: string;
  dueDate: string;
  isPromoItem: string;
}

export const OrderTableColumNameMapper: KeyValueI[] = [
  {
    key: 'inHandDateBy',
    value: 'In Hands Date',
  },
  {
    key: 'orderAmount',
    value: 'Order Amount'
  },
  {
    key: 'All',
    value: '* All *',
  },
  {
    key: 'orderNo',
    value: 'Order #',
  },
  {
    key: 'summaryBillingNumber',
    value: 'Summary Billing #',
  },
  {
    key: 'orderIdentity',
    value: 'Order Identity',
  },
  {
    key: 'contactName',
    value: 'Contact',
  },
  {
    key: 'salesPerson',
    value: 'Sales Rep',
  },
  {
    key: 'accountName',
    value: 'Account',
  },
  {
    key: 'orderType',
    // value: 'Type',
    value: 'Order Type',
  },
  {
    key: 'orderDate',
    value: 'Order Date',
  },
  {
    key: 'bookedDate',
    value: 'Booked Date',
  },
  {
    key: 'orderStatus',
    value: 'Order Status',
  },
  {
    key: 'paymentStatus',
    value: 'Payment',
  },
  {
    key: 'totalPrice',
    value: 'Total',
  },
  {
    key: 'balance',
    value: 'Balance',
  },
  {
    key: 'actions',
    value: 'Actions',
  },
  // ask backend mapped two different places two ways
  {
    key: 'corporateIdentityName',
    value: 'Corporate Identity',
  },
  {
    key: 'partnerIdentityId',
    // value: 'Corporate Identity',
    value: 'Corporate Identity',
  },
  {
    key: 'projectName',
    value: 'Project Name',
  },
  {
    key: 'customerPo',
    value: 'Customer Po',
  },
  {
    key: 'csrName',
    value: 'CSR Name',
  },
  {
    key: 'csr',
    value: 'CSR Name',
  },
  {
    key: 'creditTerms',
    value: 'Credit Terms',
  },
  {
    key: 'productionManagerName',
    value: 'Prod. Manager',
  },
  {
    key: 'shipVia',
    value: 'Ship Via',
  },
  {
    key: 'billComplete',
    value: 'Bill Complete',
  },
  {
    key: 'isRushOrder',
    value: 'Is Rush Order',
  },
  {
    key: 'shipDate',
    // value: 'Customer Ship Date',
    value: 'Ship Date (Customer)',
  },
  {
    key: 'shipDateFrom',
    value: 'Ship Date From (Customer)',
  },
  {
    key: 'shipDateTo',
    value: 'Ship Date To (Customer)',
  },
  {
    key: 'inHandDateByTo',
    value: 'In Hands Date To (Customer)',
  },
  {
    key: 'inHandDateByFrom',
    value: 'In Hands Date From (Customer)',
  },
  {
    key: 'bookedDateFrom',
    value: 'Booked Date From',
  },
  {
    key: 'bookedDateTo',
    value: 'Booked Date To',
  },
  {
    key: 'orderDateTo',
    value: 'Order Date To',
  },
  {
    key: 'orderDateFrom',
    value: 'Order Date From',
  },
  {
    key: 'partnerIdentityName',
    value: 'Corp. Identity',
  },
  {
    key: 'tagId',
    value: 'Tag',
  },
  {
    key: 'tag',
    value: 'Tag',
  },
  {
    key: 'inRushOrder',
    value: 'Is Rush Order',
  },
  {
    key: 'favourite',
    value: 'Favorite',
  },
  {
    key: 'comments',
    value: 'Comments',
  },
  {
    key: 'task',
    value: 'Activities',
  },
  {
    key: 'invoiceDate',
    value: 'Invoice Date'
  },
  {
    key: 'invoiceDateFrom',
    value: 'Invoice Date From'
  },
  {
    key: 'invoiceDateTo',
    value: 'Invoice Date To'
  },
  {
    key: 'dueDate',
    value: 'Due Date '
  },
  {
    key: 'salesPersonId',
    value: 'Sales Person Id'
  },
  {
    key: 'attentionTo',
    value: 'Attention To'
  },
  {
    key: 'factoryShipDate',
    value: 'Factory Ship Date'
  },
  {
    key: 'notePackagingSlip',
    value: 'Note Packaging Slip'
  },
  {
    key: 'factoryShipDate',
    value: 'Factory Ship Date'
  },
  {
    key: 'commissionGroupId',
    value: 'Commission Group Id'
  },
  {
    key: 'expectedPrintDate',
    value: 'Expected Print Date'
  },
  {
    key: 'supplierShipDate',
    value: 'Supplier Ship Date'
  },
  {
    key: 'commissionGroupId',
    value: 'CommissionGroupId'
  },
  {
    key: 'expectedPrintDate',
    value: 'Expected Print Date'
  },
  {
    key: 'supplierShipDate',
    value: 'Supplier Ship Date'
  },
  {
    key: 'supplierInHandsDate',
    value: 'Supplier In Hands Date'
  },
  {
    key: 'csrEmbroideryUserId',
    value: 'CSR Embroidery User Id'
  },
  {
    key: 'csrScreenprintUserId',
    value: 'Csr Screen Print User Id'
  },
  {
    key: 'productionManagerId',
    value: 'Production Manager Id'
  },
  {
    key: 'proofDueDate',
    value: 'Proof Due Date'
  },
  {
    key: 'shippingAccountNo',
    value: 'Shipping Account #'
  },
  {
    key: 'proformaDate',
    value: 'Pre Invoice Date'
  },
  {
    key: 'salesManagerId',
    value: 'Sales Manager Id'
  },
  {
    key: 'orderNoWithPrefix',
    value: 'Order No Prefix'
  },
  {
    key: 'alternateAccountNumber',
    value: 'Alternate Account #'
  },
  {
    key: 'altNumber',
    value: 'Alt Number'
  },
  {
    key: 'syncStatus',
    value: 'Sync Status'
  },
  {
    key: 'dueDate',
    value: 'Due Date'
  },
  {
    key: 'dueDateFrom',
    value: 'Due Date From',
  },
  {
    key: 'dueDateTo',
    value: 'Due Date To',
  },
  {
    key: 'isPromoItem',
    value: 'Promo Item'
  },
  {
    key: 'kanbanStatus',
    value: 'Kanban Status'
  }
];

export const QuotesTableColumNameMapper: KeyValueI[] = [
  {
    key: 'inHandDateBy',
    value: 'In Hands Date',
  },
  {
    key: 'All',
    value: '* All *',
  },
  {
    key: 'orderAmount',
    value: 'Order Amount'
  },
  {
    key: 'orderNo',
    value: 'Quote #',
  },
  {
    key: 'orderIdentity',
    // value: 'Identity',
    value: 'Quote Identity',
  },
  {
    key: 'contactName',
    value: 'Contact',
  },
  {
    key: 'salesPerson',
    value: 'Sales Rep',
  },
  {
    key: 'accountName',
    value: 'Account',
  },
  {
    key: 'orderType',
    // value: 'Type',
    value: 'Order Type',
  },
  {
    key: 'orderDate',
    value: 'Quote Date',
  },
  {
    key: 'bookedDate',
    value: 'Booked Date',
  },
  {
    key: 'orderStatus',
    value: 'Quote Status',
  },
  {
    key: 'paymentStatus',
    value: 'Payment',
  },
  {
    key: 'totalPrice',
    value: 'Total',
  },
  {
    key: 'balance',
    value: 'Balance',
  },
  {
    key: 'actions',
    value: 'Actions',
  },
  // ask backend mapped two different places two ways
  {
    key: 'corporateIdentityName',
    value: 'Corporate Identity',
  },
  {
    key: 'partnerIdentityId',
    // value: 'Corporate Identity',
    value: 'Corporate Identity',
  },
  {
    key: 'projectName',
    value: 'Project Name',
  },
  {
    key: 'customerPo',
    value: 'Customer Po',
  },
  {
    key: 'csrName',
    value: 'CSR Name',
  },
  {
    key: 'csr',
    value: 'CSR Name',
  },
  {
    key: 'creditTerms',
    value: 'Credit Terms',
  },
  {
    key: 'productionManagerName',
    value: 'Prod. Manager',
  },
  {
    key: 'shipVia',
    value: 'Ship Via',
  },
  {
    key: 'billComplete',
    value: 'Bill Complete',
  },
  {
    key: 'isRushOrder',
    value: 'Is Rush Order',
  },
  {
    key: 'shipDate',
    // value: 'Customer Ship Date',
    value: 'Ship Date (Customer)',
  },
  {
    key: 'shipDateFrom',
    value: 'Ship Date From (Customer)',
  },
  {
    key: 'shipDateTo',
    value: 'Ship Date To (Customer)',
  },
  {
    key: 'inHandDateByTo',
    value: 'In Hands Date To (Customer)',
  },
  {
    key: 'inHandDateByFrom',
    value: 'In Hands Date From (Customer)',
  },
  {
    key: 'bookedDateFrom',
    value: 'Booked Date From',
  },
  {
    key: 'bookedDateTo',
    value: 'Booked Date To',
  },
  {
    key: 'orderDateTo',
    value: 'Quote Date To',
  },
  {
    key: 'orderDateFrom',
    value: 'Quote Date From',
  },
  {
    key: 'partnerIdentityName',
    value: 'Corp. Identity',
  },
  {
    key: 'tagId',
    value: 'Tag',
  },
  {
    key: 'tag',
    value: 'Tag',
  },
  {
    key: 'inRushOrder',
    value: 'Is Rush Order',
  },
  {
    key: 'favourite',
    value: 'Favorite',
  },
  {
    key: 'comments',
    value: 'Comments',
  },
  {
    key: 'task',
    value: 'Activities',
  },
  {
    key: 'invoiceDate',
    value: 'Invoice Date'
  },
  {
    key: 'invoiceDateFrom',
    value: 'Invoice Date From'
  },
  {
    key: 'invoiceDateTo',
    value: 'Invoice Date To'
  },
  {
    key: 'dueDate',
    value: 'Due Date'
  },
  {
    key: 'salesPersonId',
    value: 'Sales Person Id'
  },
  {
    key: 'proformaDate',
    value: 'Pre Invoice Date'
  },
  {
    key: 'attentionTo',
    value: 'Attention To'
  },
  {
    key: 'shippingAccountNo',
    value: 'Shipping Account #'
  },
  {
    key: 'notePackagingSlip',
    value: 'Note Packaging Slip'
  },
  {
    key: 'factoryShipDate',
    value: 'Factory Ship Date'
  },
  {
    key: 'commssionGroupId',
    value: 'Commission Group Id'
  },
  {
    key: 'expectedPrintDate',
    value: 'Expected Print Date'
  },
  {
    key: 'supplierShipDate',
    value: 'Supplier Ship Date'
  },
  {
    key: 'supplierInHandsDate',
    value: 'Supplier In Hands Date'
  },
  {
    key: 'csrEmbroideryUserId',
    value: 'CSR Embroidery User Id'
  },
  {
    key: 'csrScreenprintUserId',
    value: 'CSR Screen Print User Id',
  },
  {
    key: 'productionManagerId',
    value: 'Production Manager Id'
  },
  {
    key: 'salesManagerId',
    value: 'Sales Manager Id'
  },
  {
    key: 'proofDueDate',
    value: 'Proof Due Date'
  },
  {
    key: 'alternateAccountNumber',
    value: 'Alternate Account #'
  },
  {
    key: 'altNumber',
    value: 'Alt Number'
  }
];

export const AccountsMapper: KeyValueI[] = [
  {
    key: 'alternateAccountNumber',
    value: 'Alt. Account Number'
  },
  {
    key: 'billAddress1',
    value: 'Bill Address 1',
  },
  {
    key: 'billAddress2',
    value: 'Bill Address 2',
  },
  {
    key: 'billCity',
    value: 'Bill City',
  },
  {
    key: 'accountName',
    value: 'Account Name',
  },
  {
    key: 'billCountry',
    value: 'Bill Country',
  },
  {
    key: 'billPostalCode',
    value: 'Bill Postal Code',
  },
  {
    key: 'billPostalcode',
    value: 'Bill Postal Code',
  },
  {
    key: 'billState',
    value: 'Bill State',
  },
  {
    key: 'commissionGroup',
    value: 'Commission Group',
  },
  {
    key: 'customerPO',
    value: 'Customer PO',
  },
  {
    key: 'creditTerms',
    value: 'Credit Terms',
  },
  {
    key: 'csr',
    value: 'CSR',
  },
  {
    key: 'dateCreated',
    value: 'Date Created',
  },
  {
    key: 'dateModified',
    value: 'Date Modified',
  },
  {
    key: 'dateModifiedFrom',
    value: 'Date Modified From'
  },
  {
    key: 'fax',
    value: 'Fax',
  },
  {
    key: 'firstOrderDate',
    value: 'First Order Date',
  },
  {
    key: 'highCreditLimit',
    value: 'Credit Limit',
  },
  {
    key: 'industry',
    value: 'Industry',
  },
  {
    key: 'leadSource',
    value: 'Lead Source',
  },
  {
    key: 'partnerAccount',
    value: 'Partner Account',
  },
  {
    key: 'phone',
    value: 'Phone',
  },
  {
    key: 'pricingMethods',
    value: 'Pricing Methods',
  },
  {
    key: 'rating',
    value: 'Rating',
  },
  {
    key: 'salesRep',
    value: 'Sales Rep',
  },
  {
    key: 'productionManager',
    value: 'Production Manager',
  },
  {
    key: 'shipAddress1',
    value: 'Ship Addresss 1',
  },
  {
    key: 'shipAddress2',
    value: 'Ship Address 2',
  },
  {
    key: 'shipCity',
    value: 'Ship City',
  },
  {
    key: 'shipCountry',
    value: 'Ship Country',
  },
  {
    key: 'shipPostalcode',
    value: 'Ship Postal Code',
  },
  {
    key: 'shipPostalCode',
    value: 'Ship Postal Code',
  },
  {
    key: 'shipState',
    value: 'Ship State',
  },
  {
    key: 'taxExempt',
    value: 'Tax Exempt',
  },
  {
    key: 'timeZone',
    value: 'Time Zone',
  },
  {
    key: 'parentAccount',
    value: 'Parent Account',
  },
  {
    key: 'partnerType',
    value: 'Partner Type',
  },
  {
    key: 'firstOrderDateTo',
    value: 'First Order Date To'
  },
  {
    key: 'firstOrderDateFrom',
    value: 'First Order Date From'
  },
  {
    key: 'dateCreatedFrom',
    value: 'Date Created From'
  },
  {
    key: 'dateCreatedTo',
    value: 'Date Created To'
  },
  {
    key: 'dateModifieFrom',
    value: 'Date Modified From'
  },
  {
    key: 'dateModifiedTo',
    value: 'Date Modified To '
  },
  {
    key: 'corporateIdentityName',
    value: 'Corporate Identity'
  },
  {
    key: 'tagId',
    value: 'Tag'
  },
  {
    key: 'accountType',
    value: 'Account Type'
  },
  {
    key: 'accountExtension',
    value: 'Account Extension'
  },
  {
    key: 'vendorAccountNumber',
    value: 'Vendor Account Number'
  },
  {
    key: 'defaultCurrency',
    value: 'Currency'
  },
  {
    key: 'taxExemptCertExpDate',
    value: 'Tax Exempt Expiration Date'
  }
];

export const ArtworkMapper: KeyValueI[] = [
  {
    key: 'thumbnail',
    value: 'Image'
  },
  {
    key: 'task',
    value: 'Task',
  },
  {
    key: 'designNo',
    value: 'Design No',
  },
  {
    key: 'billCity',
    value: 'Bill City',
  },
  {
    key: 'identity',
    value: 'Name',
  },
  {
    key: 'customerName',
    value: 'Customer Name',
  },
  {
    key: 'designTypeName',
    value: 'Design Type',
  },
  {
    key: 'category',
    value: 'Category',
  },
  {
    key: 'estimated',
    value: 'Estimated',
  },
  {
    key: 'dueDate',
    value: 'Due',
  },
  {
    key: 'customerPO',
    value: 'Customer PO',
  },
  {
    key: 'createdDate',
    value: 'Created',
  },
  {
    key: 'priority',
    value: 'Priority',
  },
  {
    key: 'statusName',
    value: 'Status',
  },
  {
    key: 'assignee',
    value: 'Assignee'
  },
  {
    key: 'projectName',
    value: 'Project',
  },
  {
    key: 'dateApproved',
    value: 'Date Approved',
  },
  {
    key: 'approvedBy',
    value: 'Approved By',
  },
  {
    key: 'orderNum',
    value: 'Order Number',
  },
  {
    key: 'orderIdentity',
    value: 'Order Identity',
  },
  {
    key: 'artworkContactName',
    value: 'Artwork Contact Name',
  },
  {
    key: 'artworkContactEmail',
    value: 'Artwork Contact Email',
  },
  {
    key: 'royaltyRetail',
    value: 'Royality Retail',
  },
  {
    key: 'royaltyRetailAmountType',
    value: 'Royality Retail Amount Type',
  },
  {
    key: 'royaltyWholesale',
    value: 'Royality WholeSale',
  },
  {
    key: 'royaltyWholesaleAmountType',
    value: 'Royality WholeSale Amount Type',
  },
  {
    key: 'pinned',
    value: 'Pinned',
  },
  {
    key: 'salesRep',
    value: 'Sales Rep',
  },
  {
    key: 'createdDateTo',
    value: 'Created To'
  },
  {
    key: 'createdDateFrom',
    value: 'Created From'
  },
  {
    key: 'dueDateTo',
    value: 'Due To'
  },
  {
    key: 'dueDateFrom',
    value: 'Due From'
  },
  {
    key: 'dateApprovedTo',
    value: 'Date Approved To'
  },
  {
    key: 'dateApprovedFrom',
    value: 'Date Approved From'
  },
  {
    key: 'salesManagerName',
    value: 'Sales Manager'
  },
  {
    key: 'productionManagerName',
    value: 'Prod. Manager'
  },
  {
    key: 'csrName',
    value: 'CSR'
  },
  {
    key: 'alternateAccountNumber',
    value: 'Alternate Account #'
  },
  {
    key: 'kanbanStatus',
    value: 'Kanban Status'
  },
  {
    key: 'status',
    value: 'Status'
  },
  {
    key: 'artworkLocation',
    value: 'Artwork Location'
  }
];

export const ProductsMapper: KeyValueI[] = [
  {
    key: 'productId',
    value: 'Item # '
  },
  {
    key: 'productName',
    value: 'Name',
  },
  {
    key: 'inhouseId',
    value: 'IN-House ID',
  },
  {
    key: 'productType',
    value: 'Product Type',
  },
  {
    key: 'storeNames',
    value: 'Store Names',
  },
  {
    key: 'vendorName',
    value: 'Supplier',
  },
  {
    key: 'categoryName',
    value: 'Categories',
  },
  {
    key: 'expirationDate',
    value: 'Expiration Date',
  },
  {
    key: 'source',
    value: 'Source',
  },
  {
    key: 'sourceProductSku',
    value: 'Source Product Sku',
  },
  {
    key: 'dateCreated',
    value: 'Date Created',
  },
  {
    key: 'dateModified',
    value: 'Date Modified',
  },
  {
    key: 'catalogYear',
    value: 'Catalog Year',
  },
  {
    key: 'poType',
    value: 'LI Type',
  },
  {
    key: 'specialPrice',
    value: 'Special Price',
  },
  {
    key: 'productChannel',
    value: 'Product Channel',
  },
  {
    key: 'prodStatus',
    value: 'Status',
  },
  {
    key: 'prodKind',
    value: 'Kind',
  },
  {
    key: 'msrp',
    value: 'MSRP',
  },
  {
    key: 'calculatorType',
    value: 'Calculator Type',
  },
  {
    key: 'customerName',
    value: 'Customer',
  },
  {
    key: 'countryOrigin',
    value: 'Country Origin',
  },
  {
    key: 'assignedUserName',
    value: 'Assigned User',
  },
  {
    key: 'productOrderType',
    value: 'Product Order Type',
  },
  {
    key: 'manufacturerName',
    value: 'Manufacture',
  },
  {
    key: 'autoPullEvents',
    value: 'Auto-pull Events',
  },
  {
    key: 'productionTime',
    value: 'Production Time',
  },
  {
    key: 'dateCreatedFrom',
    value: 'Created From',
  },
  {
    key: 'dateCreatedTo',
    value: 'Created To',
  },
  {
    key: 'productStatus',
    value: 'Product Status',
  }
];

export const ProductionMapper: KeyValueI[] = [
  {
    key: 'customerName',
    value: 'Customer'
  },
  {
    key: 'orderName',
    value: 'Order',
  },
  {
    key: 'decoTypeName',
    value: 'Decoration Type',
  },
  {
    key: 'productName',
    value: 'Product Name',
  },
  {
    key: 'machineName',
    value: 'Equipment',
  },
  {
    key: 'variationName',
    value: 'Variation',
  },
  {
    key: 'statusName',
    value: 'Status',
  },
  {
    key: 'vendorName',
    value: 'Vendor'
  },
  {
    key: 'detailName',
    value: 'Decoration Detail',
  },
  {
    key: 'qty',
    value: 'Quantity',
  },
  {
    key: 'priorityName',
    value: 'Priority',
  },
  {
    key: 'color',
    value: 'Color',
  },
  {
    key: 'size',
    value: 'Size',
  },
  {
    key: 'detailCount',
    value: 'Decoration Detail Count',
  },
  {
    key: 'detailDescription',
    value: 'Decoration Detail Desc'
  },
  {
    key: 'hours',
    value: 'Hours',
  },
  {
    key: 'due',
    value: 'Due Date',
  },
  {
    key: 'productionRate',
    value: 'Production Rate',
  },
  {
    key: 'workOrderNo',
    value: 'Work Order #',
  },
  {
    key: 'action',
    value: 'Action',
  },
  {
    key: 'decorationGroup',
    value: 'Decoration Group',
  },
  {
    key: 'scheduleDate',
    value: 'Schedule Date',
  },
  {
    key: 'position',
    value: 'Position',
  }
];

export const LeadsMapper: KeyValueI[] = [
  {
    key: 'title',
    value: 'Title'
  },
  {
    key: 'status',
    value: 'Status',
  },
  {
    key: 'contactName',
    value: 'Contact Name',
  },
  {
    key: 'birthdate',
    value: 'Birth Date',
  },
  {
    key: 'accountName',
    value: 'Account Name',
  },
  {
    key: 'corporateIdentityName',
    value: 'Corporate Identity',
  },
  {
    key: 'createdByName',
    value: 'Created By',
  },
  {
    key: 'dateCreated',
    value: 'Created'
  },
  {
    key: 'dateModified',
    value: 'Modified',
  },
  {
    key: 'description',
    value: 'Description',
  },
  {
    key: 'email',
    value: 'Email',
  },
  {
    key: 'phoneWork',
    value: 'Phone Number',
  },
  {
    key: 'firstName',
    value: 'First Name',
  },
  {
    key: 'lastName',
    value: 'Last Name',
  },
  {
    key: 'salesRep',
    value: 'Sales Rep',
  },
  {
    key: 'website',
    value: 'Website'
  },
  {
    key: 'name',
    value: 'Name',
  },
  {
    key: 'productionManagerName',
    value: 'Production Manager',
  },
  {
    key: 'salesManagerName',
    value: 'Sales Manager',
  },
  {
    key: 'rating',
    value: 'Rating',
  },
  {
    key: 'referedBy',
    value: 'Refered By',
  },
  {
    key: 'leadSource',
    value: 'Lead Source ',
  },
  {
    key: 'dateCreatedFrom',
    value: 'Created From',
  },
  {
    key: 'dateCreatedTo',
    value: 'Created To',
  },
  {
    key: 'tagId',
    value: 'Tag',
  },
  {
    key: 'tag',
    value: 'Tag',
  },
  {
    key: 'productsOfInterest',
    value: 'Products Of Interest',
  }
];

export const OpportunitiesMapper: KeyValueI[] = [
  {
    key: 'name',
    value: 'Name'
  },
  {
    key: 'accountName',
    value: 'Account Name',
  },
  {
    key: 'contactName',
    value: 'Contact Name',
  },
  {
    key: 'leadSource',
    value: 'Lead Source',
  },
  {
    key: 'opportunityType',
    value: 'Opportunity Type',
  },
  {
    key: 'salesStage',
    value: 'Sales Stage',
  },
  {
    key: 'amount',
    value: 'Amount',
  },
  {
    key: 'dateCreated',
    value: 'Created'
  },
  {
    key: 'dateModified',
    value: 'Modified',
  },
  {
    key: 'salesRep',
    value: 'Sales Rep',
  },
  {
    key: 'opportunityNo',
    value: 'Opportunity No',
  },
  {
    key: 'probability',
    value: 'Probability',
  },
  {
    key: 'productionManagerName',
    value: 'Production Manager',
  },
  {
    key: 'salesManagerName',
    value: 'Sales Manager',
  },
  {
    key: 'assignedSourcingRep',
    value: 'Sourcing Rep',
  },
  {
    key: 'csrName',
    value: 'CSR'
  },
  {
    key: 'createdBy',
    value: 'Created By',
  },
  {
    key: 'dateClosed',
    value: 'Close Date',
  },
  {
    key: 'inhandsDate',
    value: 'In Hands Date',
  },
  {
    key: 'eventDate',
    value: 'Event Date',
  },
  {
    key: 'dateClosedFrom',
    value: 'Close Date From',
  },
  {
    key: 'dateClosedTo',
    value: 'Close Date To',
  },
  {
    key: 'tagId',
    value: 'Tag',
  },
  {
    key: 'tag',
    value: 'Tag',
  }
];

export const ContactsMapper: KeyValueI[] = [
  {
    key: 'title',
    value: 'Title'
  },
  {
    key: 'contactName',
    value: 'Contact Name',
  },
  {
    key: 'accountName',
    value: 'Account Name',
  },
 {
    key: 'dateCreated',
    value: 'Created'
  },
  {
    key: 'dateModified',
    value: 'Modified',
  },
  {
    key: 'email',
    value: 'Email',
  },
  {
    key: 'salesRep',
    value: 'Assigned To',
  },
  {
    key: 'productionManagerName',
    value: 'Production Manager',
  },
  {
    key: 'salesManagerName',
    value: 'Sales Manager',
  },
  {
    key: 'leadSource',
    value: 'Lead Source ',
  },
  {
    key: 'dateCreatedFrom',
    value: 'Created From',
  },
  {
    key: 'dateCreatedTo',
    value: 'Created To',
  },
  {
    key: 'tagId',
    value: 'Tag',
  },
  {
    key: 'tag',
    value: 'Tag',
  },
  {
    key: 'csrName',
    value: 'CSR',
  },
  {
    key: 'dateRelated',
    value: 'Related Date',
  },
  {
    key: 'department',
    value: 'Department',
  },
  {
    key: 'commissionGroupName',
    value: 'Commission Group',
  },
  {
    key: 'city',
    value: 'City',
  },
  {
    key: 'state',
    value: 'State',
  },
  {
    key: 'phone',
    value: 'Phone',
  },
  {
    key: 'dateRelatedFrom',
    value: 'Related Date From',
  },
  {
    key: 'dateRelatedTo',
    value: 'Related Date To',
  },
  {
    key: 'dateModifiedFrom',
    value: 'Modified From',
  },
  {
    key: 'dateModifiedTo',
    value: 'Modified To',
  },
  {
    key: 'firstName',
    value: 'First Name',
  },
  {
    key: 'lastName',
    value: 'Last Name',
  },
  {
    key: 'shippingType',
    value: 'Shipping Type',
  },
  {
    key: 'shippingAcctNumber',
    value: 'Shipping Account Number',
  },
  {
    key: 'fax',
    value: 'Fax',
  },
  {
    key: 'productionManager',
    value: 'Production Manager',
  },
  {
    key: 'salesManager',
    value: 'Sales Manager',
  },
  {
    key: 'csr',
    value: 'CSR',
  },
  {
    key: 'accountType',
    value: 'Account Status',
  },
  {
    key: 'partnerType',
    value: 'Account Type',
  },
  {
    key: 'site',
    value: 'Site',
  }
];
